

















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import CategoryBase from './CategoryBase'
import CategoryForm from '@/components/CategoryForm.vue'
import Loader from '@/components/Loader.vue'
import { Category } from '@/models/Category'

@Component({
	components: {
		CategoryForm,
		Loader,
	},
})
export default class EditCategory extends CategoryBase {
	private currentCategory: number = NaN

	@Watch('$route.params.id', { immediate: true })
	private onNameChange(val: string) {
		this.currentCategory = parseInt(val, 10)
	}

	get category() {
		return this.$store.getters.currentCategory(this.currentCategory)
	}

	private submit(category: Category) {
		this.$store.dispatch('saveCategory', category)
			.then(() => this.$toasted.success('Category successfully updated.'),
			(error: any) => {
				this.$toasted.error(`Error: ${category.errorArray}`)
				this.category.reset()
			})
	}
}
